

  export const GamesData = [
            {
                id: 0,
                  title: "Tic Game w React Hooks",
                  images:( process.env.PUBLIC_URL +  "/assets/images/repos/ticgame.gif"),
                  alt: "Tic Game",
                  repo: "https://github.com/Kuiil7/ticgame" ,
                  demo:"https://ticgame.vercel.app/",
                  description: "A game converted game from a class based component to a full funcitonal component.",
                  myDuty:"Sole maintainer.",
                  builtWith: "Bulma.",
                  url:"N/A",
                  status: "Completed"
                },
  ];

